import { useState, useEffect } from "react";
import { API } from "../App";
import { useLanguage } from "../i18n/LanguageContext";
import { Trophy, Lock } from "lucide-react";
import axios from "axios";

const ACHIEVEMENT_ORDER = [
  "first_checkin", "first_consult", "first_diary",
  "streak_3", "streak_7", "streak_30",
  "checkins_10", "checkins_50",
  "consults_10", "challenges_7", "challenges_30"
];

const ACHIEVEMENT_ICONS = {
  first_checkin: "\u2764\ufe0f", streak_3: "\ud83d\udd25", streak_7: "\ud83d\udd25\ud83d\udd25",
  streak_30: "\ud83c\udf1f", checkins_10: "\ud83d\udcaa", checkins_50: "\ud83c\udfc6",
  first_consult: "\ud83e\udde0", consults_10: "\ud83d\ude80", first_diary: "\ud83d\udcd6",
  challenges_7: "\u2b50", challenges_30: "\ud83d\udc51"
};

const AchievementsSection = () => {
  const { t } = useLanguage();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/avatar/achievements`).then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const unlocked = new Set(data.unlocked || []);

  return (
    <div className="mt-6" data-testid="achievements-section">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-['Outfit'] font-semibold text-[#111111] text-base flex items-center gap-2">
          <Trophy className="w-4 h-4 text-[#D97706]" />
          {t("ach_title")}
        </h3>
        <span className="text-xs text-[#6B7280]">{data.unlocked.length}/{data.total_possible} {t("ach_unlocked")}</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {ACHIEVEMENT_ORDER.map((id) => {
          const isUnlocked = unlocked.has(id);
          return (
            <div
              key={id}
              className={`rounded-xl p-3 text-center transition-all ${isUnlocked ? "bg-[#FFFBEB] border border-[#FCD34D]/30" : "bg-[#F5F5F7] border border-[#E5E5EA] opacity-40"}`}
              data-testid={`achievement-${id}`}
            >
              <div className="text-2xl mb-1">{isUnlocked ? ACHIEVEMENT_ICONS[id] : <Lock className="w-5 h-5 mx-auto text-[#9CA3AF]" />}</div>
              <p className={`text-[10px] font-medium leading-tight ${isUnlocked ? "text-[#111111]" : "text-[#9CA3AF]"}`}>{t(`ach_${id}`)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementsSection;
